<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<ng-container *ngIf="step === 0">
  <div class="title">
    <img src="../../../../assets/images/compensate/fail.png" alt="" />
    <div class="txt1">抱歉，账号无法修复</div>
  </div>
  <div class="content" mat-dialog-content>
    <div class="subtitle1">
      原家庭组已彻底失效。为了保障您的权益，请您确认：
    </div>
    <div class="tabs">
      <div
        class="tab"
        (click)="changeIndex(1)"
        [ngClass]="{ active: index === 1 }"
      >
        使用新邮箱加入
      </div>
      <div
        class="tab"
        (click)="changeIndex(2)"
        [ngClass]="{ active: index === 2 }"
      >
        开通个人会员
      </div>
    </div>

    <!-- index=1 的描述 -->
    <div class="subtitle2" *ngIf="index === 1">
      提供新的 Gmail 邮箱，加入新的家庭组
    </div>
    <!-- index=2 的描述 -->
    <div class="subtitle2" *ngIf="index === 2">
      保留当前账号、观看记录和订阅内容
    </div>
  </div>

  <div class="button" [ngClass]="{ active: index === 1 }">
    <button matRipple style="background: #00ad9d" (click)="confirmPlan()">
      确认
    </button>
  </div>
  <div class="button" [ngClass]="{ active: index === 2 }">
    <button matRipple style="background: #00ad9d" (click)="confirmPlan()">
      继续
    </button>
  </div>
</ng-container>

<!-- ===== 个人会员流程 ===== -->
<ng-container *ngIf="index === 2 && step > 0">
  <div class="content" mat-dialog-content>
    <!-- Step 1: 方案概览 -->
    <ng-container *ngIf="step === 1">
      <h2 class="section-title">开通个人会员</h2>
      <p class="section-desc">确认会员时长后，再填写需要开通的 Google 账号。</p>

      <div class="summary-card">
        <div class="summary-row">
          <span class="summary-label">处理方式</span>
          <span class="summary-value">YouTube Premium 个人会员</span>
        </div>
        <!-- <div class="summary-row">
          <span class="summary-label">使用账号</span>
          <span class="summary-value">当前 Google 账号</span>
        </div> -->
      </div>

      <div class="duration-highlight">
        <div class="duration-line">
          <span class="duration-name">原订单剩余时长</span>
          <span class="duration-value">{{ remainingDaysText }}</span>
        </div>
        <div class="duration-line">
          <span class="duration-name">转换后的个人会员时长</span>
          <span class="duration-value">{{ convertedMonthsText }}</span>
        </div>
        <div class="duration-rule">剩余时长按整月向上计算</div>
      </div>

      <div class="note-box">
        <span class="note-icon">i</span>
        <span>个人会员将按月开通。处理完成后，可继续使用当前账号。</span>
      </div>
    </ng-container>

    <!-- Step 2: 填写账号信息 -->
    <ng-container *ngIf="step === 2">
      <h2 class="section-title">填写账号信息</h2>
      <p class="section-desc">请填写需要开通个人会员的账号信息。</p>

      <div class="form-group">
        <label class="form-label" for="emailInput">Google 账号</label>
        <input
          class="form-input"
          id="emailInput"
          type="text"
          autocomplete="off"
          placeholder="请输入账号邮箱"
          [(ngModel)]="email"
          [ngClass]="{ invalid: email && !emailValid }"
        />
        <!-- <div class="field-hint">账号格式必须包含 @</div> -->
        <div class="field-error">{{ getEmailError() }}</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="passwordInput">账号密码</label>
        <div class="input-wrap">
          <input
            class="form-input"
            id="passwordInput"
            [type]="showPassword ? 'text' : 'password'"
            autocomplete="new-password"
            placeholder="请输入账号密码"
            [(ngModel)]="password"
          />
          <button class="input-action" type="button" (click)="togglePassword()">
            {{ showPassword ? "隐藏" : "显示" }}
          </button>
        </div>
        <div class="field-error">{{ getPasswordError() }}</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="backupCode1Input">备用安全码 1</label>
        <input
          class="form-input"
          id="backupCode1Input"
          type="text"
          inputmode="numeric"
          maxlength="8"
          autocomplete="off"
          placeholder="请输入 8 位数字"
          [(ngModel)]="backupCode1"
          [ngClass]="{ invalid: backupCode1 && !backupCode1Valid }"
        />
        <div class="field-error">{{ getBackupCode1Error() }}</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="backupCode2Input">备用安全码 2</label>
        <input
          class="form-input"
          id="backupCode2Input"
          type="text"
          inputmode="numeric"
          maxlength="8"
          autocomplete="off"
          placeholder="请输入另一个 8 位数字"
          [(ngModel)]="backupCode2"
          [ngClass]="{ invalid: backupCode2 && !backupCode2Valid }"
        />
        <div class="field-error">{{ getBackupCode2Error() }}</div>
      </div>

      <div class="guide-card">
        <div class="guide-top">
          <div>
            <div class="guide-title">没有备用安全码？</div>
            <div class="guide-desc">
              请先开启两步验证并生成 2 个备用安全码。
            </div>
          </div>
          <button class="guide-btn" type="button" (click)="openBackupGuide()">
            官方教程
          </button>
        </div>
      </div>

      <label class="check-row">
        <input type="checkbox" [(ngModel)]="accountConfirm" />
        <span>我确认以上信息对应需要开通个人会员的账号。</span>
      </label>
    </ng-container>

    <!-- Step 3: 提交确认 -->
    <ng-container *ngIf="step === 3">
      <h2 class="section-title">确认提交</h2>
      <p class="section-desc">请核对账号，提交后将进入处理流程。</p>

      <div class="summary-card">
        <div class="summary-row">
          <span class="summary-label">Google 账号</span>
          <span class="summary-value">{{ email }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">会员类型</span>
          <span class="summary-value">YouTube Premium 个人会员</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">会员时长</span>
          <span class="summary-value">{{ convertedMonthsText }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">账号密码</span>
          <span class="summary-value">已填写</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">备用安全码 1</span>
          <span class="summary-value">已填写（8 位）</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">备用安全码 2</span>
          <span class="summary-value">已填写（8 位）</span>
        </div>
      </div>

      <div class="note-box">
        <span class="note-icon">i</span>
        <span>请确认账号、密码及两个备用安全码填写无误。</span>
      </div>

      <label class="check-row">
        <input type="checkbox" [(ngModel)]="submitConfirm" />
        <span>我已核对以上信息并确认提交。</span>
      </label>
    </ng-container>

    <!-- Step 4: 处理中 -->
    <ng-container *ngIf="step === 4">
      <div class="processing-wrap">
        <div class="spinner"></div>
        <h2 class="modal-title">正在提交处理</h2>
        <p class="modal-desc">请稍候，不要关闭页面</p>

        <div class="timeline">
          <div class="timeline-item done">
            <span class="timeline-dot">✓</span>
            <span>账号信息已确认</span>
          </div>
          <div class="timeline-item current">
            <span class="timeline-dot">•</span>
            <span>正在核对会员时长</span>
          </div>
          <div class="timeline-item">
            <span class="timeline-dot"></span>
            <span>生成个人会员处理订单</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Step 5: 提交成功 -->
    <ng-container *ngIf="step === 5">
      <div class="success-icon">✓</div>
      <h2 class="modal-title">处理申请已提交</h2>
      <p class="modal-desc">完成后会自动更新车票状态</p>

      <div class="summary-card">
        <div class="summary-row">
          <span class="summary-label">Google 账号</span>
          <span class="summary-value">{{ email }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">处理方式</span>
          <span class="summary-value">开通个人会员</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">会员时长</span>
          <span class="summary-value">{{ convertedMonthsText }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">当前状态</span>
          <span class="summary-value" style="color: #00ad9d">处理中</span>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- 各步骤的底部按钮 -->
  <div class="button active" *ngIf="step === 1">
    <button matRipple style="background: #00ad9d" (click)="goToAccount()">
      填写账号信息
    </button>
    <button matRipple class="secondary-btn" (click)="step = 0">返回</button>
  </div>

  <div class="button active" *ngIf="step === 2">
    <button
      matRipple
      style="background: #00ad9d"
      [disabled]="!accountFormValid"
      (click)="goToReview()"
    >
      核对提交信息
    </button>
    <button matRipple class="secondary-btn" (click)="step = 1">返回</button>
  </div>

  <div class="button active" *ngIf="step === 3">
    <button
      matRipple
      style="background: #00ad9d"
      [disabled]="!submitConfirm || loading"
      (click)="submitIndividualPlan()"
    >
      提交处理
    </button>
    <button matRipple class="secondary-btn" (click)="step = 2">返回修改</button>
  </div>

  <div class="button active" *ngIf="step === 5">
    <button matRipple style="background: #00ad9d" (click)="backToTickets()">
      返回我的车票
    </button>
  </div>
</ng-container>
